import { render, staticRenderFns } from "./ddlb.vue?vue&type=template&id=1d55b758&scoped=true&"
import script from "./ddlb.vue?vue&type=script&lang=js&"
export * from "./ddlb.vue?vue&type=script&lang=js&"
import style0 from "./ddlb.vue?vue&type=style&index=0&id=1d55b758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55b758",
  null
  
)

export default component.exports